export default __webpack_public_path__ + "static/timeline-04-a6616f71d04c8337c8d9e63ef48c2344.svg";